module.exports = __webpack_public_path__ + "img/refresh.0965045b.svg";